import { render } from "./ProcessDataTd.vue?vue&type=template&id=5ac6ae4f"
import script from "./ProcessDataTd.vue?vue&type=script&lang=js"
export * from "./ProcessDataTd.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__